// extracted by mini-css-extract-plugin
export default {"react-confirm-alert":"styles_react-confirm-alert__K-IYT"};